module.exports = __webpack_public_path__ + "static/img/5.ce37706.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/5.png
// module id = iy0F
// module chunks = 12